import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub, faYoutube } from "@fortawesome/free-brands-svg-icons";
import styles from "./index.module.scss";
export var Footer = function () {
    return React.createElement("div", { className: styles.container },
        React.createElement("h2", null,
            React.createElement("span", { className: styles.overline }, "yu"),
            "zu"),
        React.createElement("div", { className: styles.contact }, [
            [faLinkedin, "https://www.linkedin.com/in/quentinjanuel/"],
            [faGithub, "http://github.com/QuentinJanuel"],
            [faYoutube, "https://www.youtube.com/channel/UCNsWVxjFaJ4z43yKBySWDQw"],
        ].map(function (_a, i) {
            var icon = _a[0], url = _a[1];
            return React.createElement("a", { key: i, href: url, target: "_blank" },
                React.createElement(FontAwesomeIcon, { icon: icon }));
        })),
        React.createElement("div", { className: styles.copyrights },
            "\u00A9 ",
            new Date().getFullYear(),
            " Quentin Januel. All Rights Reserved."));
};
